import React from 'react';
import {
  Create,
  Edit,
  EditButton,
  Filter,
  List,
  maxLength,
  minLength,
  ReferenceField,
  ReferenceInput,
  required,
  SearchInput,
  TextField,
  TextInput,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import { ZippityDatagrid, ZippitySimpleForm } from '../../components';
import BulkDeleteButton from '../../components/BulkDeleteButton';
import ReferenceChild from '../../components/ReferenceChild';
import { getZ3PConfigValue, perPage } from '../../helper';

const ServiceOfferingChecklistFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <ReferenceInput
      source="service_offering_id"
      reference="service-offering"
      sort={{ field: 'short_name', order: 'ASC' }}
      perPage={perPage}
      alwaysOn
    >
      <ReferenceChild
        {...props}
        optionText="short_name"
        source="service_offering_id"
      />
    </ReferenceInput>
  </Filter>
);

const isUsingHelpText = getZ3PConfigValue('is_using_help_text');

export const ServiceOfferingChecklistList = ({ classes, ...props }) => (
  <div>
    <List
      {...props}
      filters={<ServiceOfferingChecklistFilter />}
      bulkActionButtons={<BulkDeleteButton />}
      sort={{ field: 'checklist_id', order: 'ASC' }}
      perPage={50}
    >
      <ZippityDatagrid>
        <TextField source="created_at" />
        <TextField source="modified_at" />
        <TextField source="checklist_id" />
        <ReferenceField
          source="service_offering_id"
          reference="service-offering"
          sortable={false}
        >
          <TextField source="short_name" />
        </ReferenceField>
        <TextField source="instruction" />

        <EditButton />
      </ZippityDatagrid>
    </List>

    {isUsingHelpText && (
      <div>
        <strong>Service Checklists</strong> are{' '}
        <a href="/screenshots/employee-checklist.png" target="_blank">
          shown to our technicians in the Employee App
        </a>
        .
        <ul>
          <li>Each one shows as a checklist item to complete.</li>
          <li>
            The technician cannot mark the service as complete until all the
            checklist items are &quot;checked off&quot;.
          </li>
          <li>
            The order they are shown in is from smallest &quot;Checklist
            Id&quot; to largest &quot;Checklist Id&quot;.
          </li>
          <li>
            If you need to change the order, right now the only way to do so is
            to delete the old checklist items for that service, and then create
            new ones in the correct order.
          </li>
        </ul>
      </div>
    )}
  </div>
);

const editStyles = {
  service_offering_id: { display: 'inline-block' },
};

const validateInstruction = [required(), minLength(2), maxLength(255)];

export const ServiceOfferingChecklistEdit = withStyles(editStyles)(
  ({ classes, ...props }) => (
    <Edit undoable={false} {...props}>
      <ZippitySimpleForm>
        <ReferenceInput
          source="service_offering_id"
          reference="service-offering"
          sort={{ field: 'short_name', order: 'ASC' }}
          perPage={perPage}
          validate={[required()]}
        >
          <ReferenceChild
            {...props}
            optionText="short_name"
            source="service_offering_id"
          />
        </ReferenceInput>
        <TextInput
          multiline
          validate={validateInstruction}
          source="instruction"
        />
      </ZippitySimpleForm>
    </Edit>
  ),
);

export const ServiceOfferingChecklistCreate = withStyles(editStyles)(
  ({ classes, ...props }) => (
    <Create {...props}>
      <ZippitySimpleForm>
        <ReferenceInput
          source="service_offering_id"
          reference="service-offering"
          sort={{ field: 'short_name', order: 'ASC' }}
          perPage={perPage}
          validate={[required()]}
        >
          <ReferenceChild
            {...props}
            optionText="short_name"
            source="service_offering_id"
          />
        </ReferenceInput>
        <TextInput
          multiline
          validate={validateInstruction}
          source="instruction"
        />
      </ZippitySimpleForm>
    </Create>
  ),
);
